// extracted by mini-css-extract-plugin
export var locationCard = "_q8-0";